/* FRØYA GOURMET — froya-utlevering.js v5 (01.11.2026)

   Live nedtelling for utleveringer.
   Leser data fra <script type="application/json" data-fg-utl> (snippets/froya-utleveringer.liquid).

   Elementer den bygger (tomme beholdere i seksjonene):
     [data-fg-utl-neste]   stort kort: neste utlevering med nedtelling
     [data-fg-utl-kort]    kort per sted, gruppert på dato, hver med egen nedtelling
     [data-fg-utl-liste]   liste med nedtelling per sted. Brukes på forsiden (data-max="6")
                           og på Utleveringssteder-siden (data-max="alle").
                           data-fallback="<selector>" skjules når lista vises

   v3: møtested + «Vis i kart»-lenke i listeraden.
   v4: kortene har data-region (for filterknapper på Utleveringssteder-siden) og
   en «Vis i kart»-lenke under møtestedet.
   v5 (FART): nedtellingen rører bare det som faktisk er synlig. Elementene slås opp én gang (ikke hvert
   sekund), seksjoner utenfor skjermen hoppes over (IntersectionObserver), ingenting skjer i en bakgrunnsfane,
   og full ombygging/«Pågår nå»-sjekk kjøres bare når en start- eller sluttid faktisk passeres.
   Resultatet på skjermen er det samme som før. Bygges første gang etter at siden er tegnet (ikke før).

   Når en utlevering er i gang vises «Pågår nå», og når den er over forsvinner den og alt bygges på nytt.
   Finnes det ingen kommende utleveringer, skjules beholderne (siden faller tilbake til den statiske
   teksten). Tidspunktene er norsk tid uavhengig av besøkendens tidssone; selve nedtellingen bruker
   besøkendens klokke.
*/
(function () {
  'use strict';
  if (window.__fgUtl) return;
  window.__fgUtl = true;

  var DAG = ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'];
  var MND = ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember'];

  var alle = [];
  var sigForrige = null;
  var tidEls = [];
  var klokker = [];
  var grense = Infinity;
  var obs = null;
  var observerte = [];

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function stor(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

  function les() {
    var el = document.querySelector('script[data-fg-utl]');
    if (!el) return [];
    var d;
    try { d = JSON.parse(el.textContent); } catch (e) { return []; }
    var off = (d && d.offset) || '+01:00';
    var rader = (d && d.utleveringer) || [];
    var ut = [];
    for (var i = 0; i < rader.length; i++) {
      var u = rader[i];
      if (!u || !u.dato || !u.fra || !u.til) continue;
      var p = String(u.dato).split('-');
      if (p.length !== 3) continue;
      var start = Date.parse(u.dato + 'T' + u.fra + ':00' + off);
      var slutt = Date.parse(u.dato + 'T' + u.til + ':00' + off);
      if (isNaN(start) || isNaN(slutt)) continue;
      ut.push({
        id: u.id || (u.sted + '-' + u.dato),
        sted: u.sted || '',
        region: u.region || '',
        mote: u.mote || '',
        kart: /^https:\/\//.test(u.kart || '') ? u.kart : '',
        dato: u.dato,
        fra: u.fra,
        til: u.til,
        dag: new Date(Date.UTC(+p[0], +p[1] - 1, +p[2])).getUTCDay(),
        d: +p[2],
        m: +p[1] - 1,
        start: start,
        slutt: slutt
      });
    }
    ut.sort(function (a, b) { return a.start - b.start; });
    return ut;
  }

  function kommende(maks) {
    var na = Date.now();
    var r = [];
    for (var i = 0; i < alle.length; i++) {
      if (alle[i].slutt > na) r.push(alle[i]);
    }
    return maks ? r.slice(0, maks) : r;
  }

  function delTid(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    var d = Math.floor(s / 86400); s -= d * 86400;
    var t = Math.floor(s / 3600); s -= t * 3600;
    var m = Math.floor(s / 60); s -= m * 60;
    return { d: d, t: t, m: m, s: s };
  }

  function tidTekst(start, na) {
    if (na >= start) return 'Pågår nå';
    var p = delTid(start - na);
    if (p.d > 0) return p.d + 'd ' + pad(p.t) + 't ' + pad(p.m) + 'm ' + pad(p.s) + 's';
    if (p.t > 0) return pad(p.t) + 't ' + pad(p.m) + 'm ' + pad(p.s) + 's';
    return pad(p.m) + 'm ' + pad(p.s) + 's';
  }

  function datoLang(u) { return DAG[u.dag] + ' ' + u.d + '. ' + MND[u.m]; }

  function kartUrl(u) {
    if (u.kart) return u.kart;
    var q = [u.mote, u.sted, 'Norge'].filter(Boolean).join(', ');
    return 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(q);
  }

  function tidSpan(u) {
    return '<span class="fg-utl-tid" data-fg-utl-tid data-start="' + u.start + '" data-slutt="' + u.slutt + '"></span>';
  }

  function visFallback(el, harLive) {
    var sel = el.getAttribute('data-fallback');
    if (!sel) return;
    var fb = document.querySelector(sel);
    if (fb) fb.hidden = harLive;
  }

  /* --- Live-liste (forsiden) --------------------------------------------- */
  function byggListe(el) {
    var mx = el.getAttribute('data-max');
    var maks = mx === 'alle' ? 0 : (parseInt(mx, 10) || 6);
    var ut = kommende(maks);
    if (!ut.length) { el.hidden = true; el.innerHTML = ''; visFallback(el, false); return; }
    var rader = '';
    for (var i = 0; i < ut.length; i++) {
      var u = ut[i];
      rader += '<li class="fg-utl-rad">' +
        '<span class="fg-utl-sted">' + esc(u.sted) + '</span>' +
        '<span class="fg-utl-nar">' + datoLang(u) + ' · ' + u.fra + '–' + u.til + (u.region ? ' · ' + esc(u.region) : '') + '</span>' +
        (u.mote
          ? '<span class="fg-utl-mote"><span class="fg-utl-mote__tekst">' + esc(u.mote) + '</span>' +
            '<a class="fg-utl-mote__kart" href="' + esc(kartUrl(u)) + '" target="_blank" rel="noopener">Vis i kart ↗</a></span>'
          : '') +
        tidSpan(u) + '</li>';
    }
    el.innerHTML = '<p class="fg-utl-live"><i class="fg-utl-puls" aria-hidden="true"></i>Live · neste utleveringer</p>' +
      '<ul class="fg-utl-rader" role="list">' + rader + '</ul>';
    el.hidden = false;
    visFallback(el, true);
  }

  /* --- Kort per sted, gruppert på dato ---------------------------------- */
  function byggKort(el) {
    var ut = kommende();
    if (!ut.length) { el.hidden = true; el.innerHTML = ''; return; }
    var html = '';
    var forrige = null;
    for (var i = 0; i < ut.length; i++) {
      var u = ut[i];
      if (u.dato !== forrige) {
        if (forrige !== null) html += '</ul></div>';
        html += '<div class="fg-utl-dag"><h3 class="fg-utl-dag__tittel">' + stor(datoLang(u)) + '</h3><ul class="fg-utl-kortrad" role="list">';
        forrige = u.dato;
      }
      html += '<li class="fg-utl-kort" data-region="' + esc(u.region) + '">' +
        '<p class="fg-utl-kort__kl">kl ' + u.fra + '–' + u.til + (u.region ? ' · ' + esc(u.region) : '') + '</p>' +
        '<h4 class="fg-utl-kort__sted">' + esc(u.sted) + '</h4>' +
        (u.mote ? '<p class="fg-utl-kort__mote">' + esc(u.mote) + '</p>' +
          '<a class="fg-utl-kort__kart" href="' + esc(kartUrl(u)) + '" target="_blank" rel="noopener">Vis i kart ↗</a>' : '') +
        '<p class="fg-utl-kort__ned"><span class="fg-utl-kort__lab">Starter om</span>' + tidSpan(u) + '</p>' +
        '</li>';
    }
    html += '</ul></div>';
    el.innerHTML = html;
    el.hidden = false;
  }

  /* --- Stort kort: neste utlevering ------------------------------------- */
  function byggNeste(el) {
    var u = kommende(1)[0];
    if (!u) { el.hidden = true; el.innerHTML = ''; return; }
    el.innerHTML = '<div class="fg-wrap fg-utl-neste__in">' +
      '<div>' +
        '<p class="fg-utl-neste__etikett"><i class="fg-utl-puls" aria-hidden="true"></i><span class="fg-utl-neste__etikett-tekst">Neste utlevering</span></p>' +
        '<h2 class="fg-utl-neste__sted">' + esc(u.sted) + (u.region ? '<span>' + esc(u.region) + '</span>' : '') + '</h2>' +
        '<p class="fg-utl-neste__nar">' + datoLang(u) + ' · kl ' + u.fra + '–' + u.til + '</p>' +
        (u.mote ? '<p class="fg-utl-neste__mote">' + esc(u.mote) + '</p>' : '') +
      '</div>' +
      '<div>' +
        '<div class="fg-utl-klokke" data-fg-utl-klokke data-start="' + u.start + '" data-slutt="' + u.slutt + '" role="timer" aria-label="Nedtelling til neste utlevering">' +
          '<span><b data-u="d">0</b><i>dager</i></span>' +
          '<span><b data-u="t">00</b><i>timer</i></span>' +
          '<span><b data-u="m">00</b><i>min</i></span>' +
          '<span><b data-u="s">00</b><i>sek</i></span>' +
        '</div>' +
        '<p class="fg-utl-pagar">Vi står på stedet nå – kom og hent!</p>' +
      '</div>' +
    '</div>';
    el.classList.remove('er-na');
    el.hidden = false;
  }

  function each(sel, fn) {
    var l = document.querySelectorAll(sel);
    for (var i = 0; i < l.length; i++) fn(l[i]);
  }

  function signatur() {
    var ut = kommende(30);
    var ids = [];
    for (var i = 0; i < ut.length; i++) ids.push(ut[i].id);
    return ids.join(',');
  }

  /* Neste tidspunkt der noe endrer seg i struktur eller status (start eller slutt som passeres). */
  function beregnGrense() {
    var na = Date.now(), g = Infinity;
    for (var i = 0; i < alle.length; i++) {
      if (alle[i].start > na && alle[i].start < g) g = alle[i].start;
      if (alle[i].slutt > na && alle[i].slutt < g) g = alle[i].slutt;
    }
    grense = g;
  }

  function beholder(el) {
    return el.closest('[data-fg-utl-liste],[data-fg-utl-kort],[data-fg-utl-neste]') || el;
  }

  /* Slår opp elementene én gang etter hver ombygging. */
  function lagCache() {
    tidEls = [];
    klokker = [];
    each('[data-fg-utl-tid]', function (el) {
      var rad = el.closest('.fg-utl-rad, .fg-utl-kort');
      tidEls.push({
        el: el,
        start: +el.getAttribute('data-start'),
        slutt: +el.getAttribute('data-slutt'),
        rad: rad,
        lab: rad ? rad.querySelector('.fg-utl-kort__lab') : null,
        beh: beholder(el)
      });
    });
    each('[data-fg-utl-klokke]', function (k) {
      var tall = {};
      var bs = k.querySelectorAll('b[data-u]');
      for (var i = 0; i < bs.length; i++) tall[bs[i].getAttribute('data-u')] = bs[i];
      var kort = k.closest('[data-fg-utl-neste]');
      klokker.push({
        k: k,
        start: +k.getAttribute('data-start'),
        tall: tall,
        kort: kort,
        et: kort ? kort.querySelector('.fg-utl-neste__etikett-tekst') : null,
        beh: kort || k
      });
    });
    if (obs) {
      var alleBeh = [];
      each('[data-fg-utl-liste],[data-fg-utl-kort],[data-fg-utl-neste]', function (b) { alleBeh.push(b); });
      for (var j = 0; j < alleBeh.length; j++) {
        if (observerte.indexOf(alleBeh[j]) < 0) { observerte.push(alleBeh[j]); obs.observe(alleBeh[j]); }
      }
    }
  }

  function bygg() {
    sigForrige = signatur();
    each('[data-fg-utl-liste]', byggListe);
    each('[data-fg-utl-kort]', byggKort);
    each('[data-fg-utl-neste]', byggNeste);
    lagCache();
    beregnGrense();
  }

  function erSynlig(beh) { return beh.__fgSyn !== false; }

  function oppdater(tving) {
    if (document.hidden && !tving) return;
    var na = Date.now();
    if (na >= grense) {
      if (signatur() !== sigForrige) bygg();
      beregnGrense();
      tving = true;
    }

    for (var i = 0; i < tidEls.length; i++) {
      var t = tidEls[i];
      if (!tving && !erSynlig(t.beh)) continue;
      var tekst = tidTekst(t.start, na);
      if (t.el.textContent !== tekst) t.el.textContent = tekst;
      if (t.rad) {
        var pagar = na >= t.start && na < t.slutt;
        if (pagar !== t.rad.classList.contains('er-na')) t.rad.classList.toggle('er-na', pagar);
        if (t.lab) { var skjul = na >= t.start; if (t.lab.hidden !== skjul) t.lab.hidden = skjul; }
      }
    }

    for (var j = 0; j < klokker.length; j++) {
      var c = klokker[j];
      if (!tving && !erSynlig(c.beh)) continue;
      var p = delTid(c.start - na);
      var vis = { d: String(p.d), t: pad(p.t), m: pad(p.m), s: pad(p.s) };
      for (var u in vis) {
        var b = c.tall[u];
        if (b && b.textContent !== vis[u]) b.textContent = vis[u];
      }
      if (c.kort) {
        var gar = na >= c.start;
        if (gar !== c.kort.classList.contains('er-na')) c.kort.classList.toggle('er-na', gar);
        if (c.et) {
          var tx = gar ? 'Pågår nå' : 'Neste utlevering';
          if (c.et.textContent !== tx) c.et.textContent = tx;
        }
      }
    }
  }

  function init() {
    alle = les();
    if (!alle.length) return;
    if ('IntersectionObserver' in window) {
      obs = new IntersectionObserver(function (es) {
        var nyttSynlig = false;
        for (var i = 0; i < es.length; i++) {
          es[i].target.__fgSyn = es[i].isIntersecting;
          if (es[i].isIntersecting) nyttSynlig = true;
        }
        if (nyttSynlig) oppdater(true);
      }, { rootMargin: '300px 0px' });
    }
    bygg();
    oppdater(true);
    setInterval(oppdater, 1000);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) oppdater(true); });
  }

  /* Første bygging etter at siden er tegnet, så den ikke konkurrerer med hero-animasjonen. */
  function start() {
    if (window.requestIdleCallback) window.requestIdleCallback(init, { timeout: 1200 });
    else setTimeout(init, 300);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();